import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScanConfig } from '../models/scan-config';
import { ApiService } from './api.service';

@Injectable()
export class ScanConfigService extends ApiService {

  /**
   * Fetch all ScanConfigs
   */
  listScanConfigs(organizationId: number, params?: any): Observable<ScanConfig[]> {
    let url = `organizations/${organizationId}/scan_configs`;
    return this.list(ScanConfig, url, params);
  }

  /**
   * create scan config
   */
  createScanConfig(scanConfig: ScanConfig): Observable<ScanConfig> {
    let url = `organizations/${scanConfig.organizationId}/scan_configs`;
    return this.create(scanConfig, url);
  }

  /**
   * update scan config
   */
  updateScanConfig(scanConfig: ScanConfig): Observable<ScanConfig> {
    let url = `organizations/${scanConfig.organizationId}/scan_configs/${scanConfig.id}`;
    return this.update(scanConfig, url);
  }

}
